import { SectionWrapper } from '@features/campaigns/shared/components/Review/SectionWrapper/SectionWrapper';
import { getCampaignAdProductsCountryConfig } from '@features/campaigns/shared/config/adProductsCountryConfig.ts';
import { AdProductsDisplayCreatives } from '@features/campaigns/shared/containers/Review/AdProducts/components/AdProductsDisplayCreatives/AdProductsDisplayCreatives.tsx';
import { AdProductsSummary } from '@features/campaigns/shared/containers/Review/AdProducts/components/AdProductsSummary/AdProductsSummary.tsx';
import { AdProductsVideoCreatives } from '@features/campaigns/shared/containers/Review/AdProducts/components/AdProductsVideoCreatives/AdProductsVideoCreatives.tsx';
import { getAdProductsReviewVisibility } from '@features/campaigns/shared/containers/Review/AdProducts/getAdProductsReviewVisibility.ts';
import { AdProductsData } from '@features/campaigns/shared/containers/Review/Review.dto';
import { ReviewSectionProps } from '@features/campaigns/shared/containers/Review/types';
import { useCampaignCountry } from '@features/campaigns/shared/providers/CampaignCountryProvider/useCampaignCountry.ts';

export function AdProducts({
  headerText,
  ctaButtonCallback,
  campaignType,
  campaignStatus,
  data,
  mediaType,
  campaignId,
  isCurrentUserExternal,
  accessRights,
}: ReviewSectionProps<AdProductsData>) {
  const { countryCode } = useCampaignCountry();
  const countryConfig = getCampaignAdProductsCountryConfig(countryCode);
  const visibility = getAdProductsReviewVisibility({
    campaignType,
    campaignStatus,
    mediaType,
    data,
    accessRights,
    isCurrentUserExternal,
    countryConfig,
  });

  return (
    <SectionWrapper headerText={headerText} ctaButtonCallback={ctaButtonCallback}>
      <div className='grid' data-testid='ad-products-section'>
        <AdProductsSummary data={data} visibility={visibility.summary} />
        {visibility.videoCreatives.shouldShow && <AdProductsVideoCreatives data={data} />}
        {visibility.displayCreatives.shouldShow && (
          <AdProductsDisplayCreatives data={data} visibility={visibility.displayCreatives} campaignId={campaignId} />
        )}
      </div>
    </SectionWrapper>
  );
}
